import { Dispatch } from 'redux';

import { requestAPI, requestAPIHoldingData } from 'src/redux/data/actions';
import { RootState } from 'src/redux/store';
import { SECTION_DETAIL_DATA_KEY } from 'src/redux/view/constants';
import {
  ASSET_STATUSES,
  ASSET_STATUSES_URL,
  ASSETS,
  ASSETS_URL,
} from './constants';
import {
  IAssetsData,
  IMapDispatchToPropsReturn,
  IMapStateToPropsReturn,
  IOwnProps,
} from './types';

export const mapStateToProps = (state: RootState): IMapStateToPropsReturn => {
  const newState = {
    [ASSET_STATUSES]: {
      data: null,
      isFetching: false,
      error: null,
      ...state.viewData[ASSET_STATUSES_URL],
    },
    [ASSETS]: {
      data: null,
      isFetching: false,
      error: null,
      ...state.viewData[ASSETS_URL],
    },
    sectionData: { ...state.viewData?.[SECTION_DETAIL_DATA_KEY] },
  };
  return newState;
};

export const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: IOwnProps,
): IMapDispatchToPropsReturn => {
  return {
    dispatchFetch: {
      [ASSET_STATUSES]: () => {
        dispatch(
          requestAPI(ASSET_STATUSES_URL, {
            url_format: {
              _report_: ownProps.reportPk,
              _office_: ownProps.officeCode,
            },
          }),
        );
      },
      [ASSETS]: () => {
        dispatch(
          requestAPI(ASSETS_URL, {
            url_format: {
              _report_: ownProps.reportPk,
              _office_: ownProps.officeCode,
            },
          }),
        );
      },
    },
    dispatchAssetStatusChange: (data: string) => {
      dispatch(
        requestAPIHoldingData(ASSET_STATUSES_URL, null, {
          url_format: {
            _report_: ownProps.reportPk,
            _office_: ownProps.officeCode,
          },
          data: data,
          method: 'post',
        }),
      );
    },
    dispatchAssetsChange: (data: IAssetsData) => {
      dispatch(
        requestAPI(ASSETS_URL, {
          url_format: {
            _report_: ownProps.reportPk,
            _office_: ownProps.officeCode,
          },
          data: data,
          method: 'post',
        }),
      );
    },
  };
};
